import type { IFormxRepository, FormUpdateInput } from '../repositories/IFormxRepository.js';
import type { FormxFormEntity } from '../entities/FormxEntity.js';

export interface UpdateFormxFormInput { id: string; data: FormUpdateInput; }
interface Deps { formxRepository: IFormxRepository; }

export function createUpdateFormxFormUseCase({ formxRepository }: Deps) {
  return async function updateFormxForm({ id, data }: UpdateFormxFormInput): Promise<FormxFormEntity | null> {
    return formxRepository.updateForm(id, data);
  };
}
